<!-- ===================== HERO ESPECIAL ===================== -->
<section class="hero-cert" id="certificado">
  <div class="hero-copy">
    <span class="badge">{{ 'certificado.badge' | translate }}</span>
    <h1 [innerHTML]="'certificado.heroTitleHtml' | translate"></h1>
    <p [innerHTML]="'certificado.heroPHtml' | translate"></p>
    <div class="hero-actions">
      <a class="btn line" routerLink="/certificado" fragment="ejemplo">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><path d="M14 2v6h6"/></svg>
        {{ 'certificado.heroExample' | translate }}
      </a>
      <a class="btn ghost" routerLink="/certificado" fragment="video">{{ 'certificado.heroHow' | translate }}</a>
    </div>
  </div>
  <div class="hero-doc">
    <img [src]="heroDoc" [alt]="'certificado.heroDocAlt' | translate">
  </div>
</section>

<!-- ===================== VÍDEO PROTAGONISTA ===================== -->
<section class="cert-video" id="video">
  <span class="eyebrow">{{ 'certificado.videoEyebrow' | translate }}</span>
  <h2 [innerHTML]="'certificado.videoTitleHtml' | translate"></h2>
  <p class="section-lead center">{{ 'certificado.videoLead' | translate }}</p>
  <div class="video-wrap" [class.playing]="playing">
    <ng-container *ngIf="!playing">
      <img class="poster" [src]="poster" alt="">
      <button class="video-play" type="button" (click)="playVideo()" aria-label="Reproducir vídeo"></button>
    </ng-container>
    <iframe *ngIf="videoUrl as url" [src]="url"
            title="Vídeo certificado de expedición GESVATEC PackCert"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowfullscreen></iframe>
  </div>
</section>

<!-- ===================== QUÉ ES ===================== -->
<section class="cert-intro">
  <div class="intro-grid">
    <div class="fb-text">
      <span class="eyebrow">{{ 'certificado.introEyebrow' | translate }}</span>
      <h2 class="section-title" [innerHTML]="'certificado.introTitleHtml' | translate"></h2>
      <p [innerHTML]="'certificado.introP1Html' | translate"></p>
      <p [innerHTML]="'certificado.introP2Html' | translate"></p>
      <p [innerHTML]="'certificado.introP3Html' | translate"></p>
    </div>
    <img [src]="introImg" [alt]="'certificado.introImgAlt' | translate">
  </div>
</section>

<!-- ===================== CÓMO SE EMITE ===================== -->
<section class="cert-flow" id="como">
  <span class="eyebrow">{{ 'certificado.howEyebrow' | translate }}</span>
  <h2 class="section-title" [innerHTML]="'certificado.howTitleHtml' | translate"></h2>
  <p class="section-lead">{{ 'certificado.howLead' | translate }}</p>
  <div class="cert-flow-grid">
    <div class="cert-flow-step" *ngFor="let i of flowSteps">
      <div class="num">{{ i + 1 }}</div>
      <h3>{{ 'certificado.flow.' + i + '.title' | translate }}</h3>
      <p [innerHTML]="'certificado.flow.' + i + '.textHtml' | translate"></p>
    </div>
  </div>
</section>

<!-- ===================== BLOCKCHAIN ===================== -->
<section class="cert-bc" id="blockchain">
  <div class="bc-grid">
    <div class="visual" aria-hidden="true"></div>
    <div class="copy">
      <span class="eyebrow">{{ 'certificado.bcEyebrow' | translate }}</span>
      <h2 [innerHTML]="'certificado.bcTitleHtml' | translate"></h2>
      <p [innerHTML]="'certificado.bcPHtml' | translate"></p>
      <ul class="checks">
        <li *ngFor="let i of bcChecks">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><path d="M5 12l5 5L20 7"/></svg>
          {{ 'certificado.bcChecks.' + i | translate }}
        </li>
      </ul>
    </div>
  </div>
</section>

<!-- ===================== ANATOMÍA DEL CERTIFICADO ===================== -->
<section class="cert" id="ejemplo">
  <span class="eyebrow center">{{ 'certificado.certEyebrow' | translate }}</span>
  <h2 class="section-title center" [innerHTML]="'certificado.certTitleHtml' | translate"></h2>
  <p class="section-lead center" [innerHTML]="'certificado.certLeadHtml' | translate"></p>
  <div class="cert-grid">
    <div class="cert-doc">
      <img [src]="heroDoc" [alt]="'certificado.certDocAlt' | translate">
    </div>
    <div class="cert-points">
      <div class="cert-point" *ngFor="let i of points">
        <span class="n">{{ i + 1 }}</span>
        <div>
          <h3>{{ 'certificado.points.' + i + '.title' | translate }}</h3>
          <p>{{ 'certificado.points.' + i + '.text' | translate }}</p>
        </div>
      </div>
    </div>
  </div>
</section>

<!-- ===================== CTA FINAL ===================== -->
<section class="cert-cta">
  <span class="eyebrow">{{ 'certificado.ctaEyebrow' | translate }}</span>
  <h2>{{ 'certificado.ctaTitle' | translate }}</h2>
  <p>{{ 'certificado.ctaP' | translate }}</p>
  <button class="btn" type="button" (click)="openDemo()">{{ 'certificado.ctaBtn' | translate }}</button>
</section>
